export { CTACentered } from './CTACentered';
export type { Props as CTACenteredProps } from './CTACentered';
